import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getRows = store => store[NAME].rows;
export const getDataTypes = store => store[NAME].dataTypes;
export const getRoleTypes = store => store[NAME].roleTypes;
export const getActiveTypes = store => store[NAME].activeTypes;
export const getKPITypes = store => store[NAME].kpiTypes;
export const getDateFormat = store => store[NAME].dateFormat;